import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "titlePages" }

import { watch, ref, Ref, onMounted, computed, shallowRef} from 'vue';
import axios from 'axios';
import Papa from "papaparse";

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import maplibregl, { LngLatLike } from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';

/********************************
 ********** CONSTANTES **********
 *******************************/
import { LABELS, TOKEN } from '@/constants/labels';
import { TIMEOUTTIME } from '@/constants/apis';
import { COLOR } from '@/constants/colors';
import CONSTAPIS from '@/constants/apis';
import CONSTMAPS from '@/constants/maps';

/********************************
 *********** SERVICES ***********
 *******************************/
import { postHeatMap } from '@/services/Smartlink/Drive';
import { getRajantLastGPS } from '@/services/Smartlink/Map';

/********************************
 ********** INTERFACES **********
 *******************************/
import { DRIVE_OBS, DRIVE_PROPS } from '@/interfaces/SmartLink/Equipos';
import { TOPO_ITEMS } from '@/interfaces/SmartLink/Topology';
import { DEFAULT_ITEMS } from '@/interfaces/SmartLink/Tables';
import { STRINGS } from '@/interfaces/SmartLink/General';

/********************************
 *********** FUNCTION ***********
 *******************************/
import { showConsoleError } from '@/functions/errors';


/**
 * Titulo de la vista
 */
import miIconoPersonalizado from '@/assets/Icons/onlysolar.png';


export default /*@__PURE__*/_defineComponent({
  __name: 'DriveView',
  setup(__props) {

const { mdAndDown } = useDisplay();

/********************************
 ************ STORE *************
 *******************************/
const store = useStore();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();

/********************************
 *********** MAPLIBRE ***********
 *******************************/
const title = computed(() => 'Drive');

/**
 * Ancho del mapa
 */
const width = ref('350');

/**
 * Ajusta el ancho del mapa dependiendo del tamaño de la pantalla
 */
watch(mdAndDown,(valor:boolean) => {
    valor ? width.value = '100%' :  width.value = '350';
})

/**
 * Parametros para el HeatMap, minutos
 */
const minutes = ref(1)

/**
 * Parametros para el HeatMap, intervalo
 */
const interval = ref(15)

/**
 * Deshabilita el boton mientras se realiza la peticion
 */
const disabledAXIOS = ref(false)

/**
 * Inicia el proceso del HeatMap mandando los parametros al script de python
 */
async function startHeatMap(){
    const params = {
        minutes: minutes.value,
        interval: interval.value
    }

    disabledAXIOS.value = true;

    const allData = await postHeatMap(params)

    disabledAXIOS.value = false

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        if(allData.data[0].includes('ERROR')){
            store.commit('showSnackBar', {type: LABELS.error, msg: allData.data[1], valor : true});
        }
        else{
            store.commit('showSnackBar', {type: LABELS.add, msg: t('snackbar.heatmapOK'), valor : true});
        }
    }
}

/**
 * Observa el valor de disabledAXIOS para iniciar el progreso
 */
watch(disabledAXIOS,(a)=> {
    if(a) startTimer()
})

/**
 * Progreso del HeatMap
 */
const progress = ref(0);

/**
 * Indica si el timer esta corriendo
 */
const isRunning = ref(false);

let totalSeconds = 0;
let elapsedSeconds = 0;
let intervalId: ReturnType<typeof setInterval> | null = null;

/**
 * Inicia el timer para la barra de progreso del HeatMap
 */
function startTimer () {
  if (!minutes.value || minutes.value <= 0) return;

  if (intervalId) {
    clearInterval(intervalId);
  }

  totalSeconds = minutes.value * 60;
  elapsedSeconds = 0;
  progress.value = 0;
  isRunning.value = true;

  intervalId = setInterval(() => {
    elapsedSeconds++;
    progress.value = (elapsedSeconds / totalSeconds) * 100;

    if (elapsedSeconds >= totalSeconds) {
      clearInterval(intervalId!);
      isRunning.value = false;
    }
  }, 1000);
}

/**
 * Checkbox del RSRP
 */
const selectedRSRP:Ref<boolean> = ref(true);

/**
 * Checkbox del RSRQ
 */
const selectedRSRQ:Ref<boolean> = ref(false);

/**
 * Checkbox del RSSI
 */
const selectedRSSI:Ref<boolean> = ref(false);

/**
 * Checkbox del SNR
 */
const selectedSNR:Ref<boolean>      = ref(false);

/**
 * Checkbox del LATENCIA
 */
const selectedLATENCIA:Ref<boolean> = ref(false);

/**
 * Muestra error si no hay datos o hay un error en las APIS
 */
const showError                     = ref(false);

/**
 * Muestra los checkboxes cuando hay datos
 */
const showCheckBoxes                = ref(false);

const COLORRED      = COLOR.red;
const COLORYELLOW   = COLOR.yellow;
const COLORGREEN    = COLOR.green;
const COLORBLUE     = COLOR.greyfake;
const COLORGREY     = COLOR.grey;

/**
 * Obtiene el color dependiendo del valor y los limites
 */
function getColorByValue(value: number, limit:number[], colors:string[]) {
    if( value === 0 ) return COLORGREY;
    let finalColor = colors;
    let selectedColor = COLORGREY;
    limit.forEach((limited,i) => {
        if(value > limited ) selectedColor = finalColor[i]
    })
    return selectedColor
}

/**
 * Array Final de RSRP
 */
const finalRSRPArray = ref<DRIVE_PROPS[]>([]);

/**
 * Objeto Final de RSRP
 */
const finalRSRPObject = ref<DRIVE_OBS>({'features': [], "type": ''});

/**
 * Array Final de RSRQ
 */
const finalRSRQArray = ref<DRIVE_PROPS[]>([]);

/**
 * Objeto Final de RSRQ
 */
const finalRSRQObject = ref<DRIVE_OBS>({'features': [], "type": ''});

/**
 * Array Final de RSSI
 */
const finalRSSIArray = ref<DRIVE_PROPS[]>([]);

/**
 * Objeto Final de RSSI
 */
const finalRSSIObject = ref<DRIVE_OBS>({'features': [], "type": ''});

/**
 * Array Final de SNR
 */
const finalSNRArray = ref<DRIVE_PROPS[]>([]);

/**
 * Objeto Final de SNR
 */
const finalSNRObject = ref<DRIVE_OBS>({'features': [], "type": ''});

/**
 * Array Final de LATENCIA
 */
const finalLATENCIAArray    = ref<DRIVE_PROPS[]>([]);

/**
 * Objeto Final de LATENCIA
 */
const finalLATENCIAObject   = ref<DRIVE_OBS>({'features': [], "type": ''});

/**
 * Obtiene las posiciones finales del poligono
 */
function getFinalPositions(lat:number, lng:number){
    let lat1 = lat + 0.0002;
    let lng1 = lng + 0.0002;
    let finalItem = [
        [ lng,  lat  ],
        [ lng1, lat  ],
        [ lng1, lat1 ],
        [ lng,  lat1 ],
        [ lng,  lat  ],
    ]
    return finalItem
}

/**
 * Llama a la funcion getInfoByIP
 * Envia el parametro del valor que desea obtener
 * Recibe objeto {
 *  ip : name
 * }
 * se usa para la lista del SELECT
 */
// const finalNameByIP:Ref<STRINGS> = ref(getInfoByIP('name'));

/**
 * Lista final de camiones
 */
const finalListTruck:Ref<TOPO_ITEMS[]>      = ref([]);

/**
 * ?Lista computada de camiones?
 */
const computedListTruck = computed(() => finalListTruck.value)

/**
 * ?Lista intermedia de camiones?
 */
const haulTrucksList:Ref<TOPO_ITEMS[]>      = ref([]);


/**
 * Obtiene todos los camiones de la API
 */
async function getAllHaulTrucks () {

    await axios.get(CONSTAPIS.APIS.value.drive.geAllIPDrive,{ timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}`} }).then((response) => {
        let finalItems = response.data.body;
        finalItems.forEach((item:string) => {
            let prevIP = item.split('.')
            let finalIP = `${prevIP[0]}.${prevIP[1]}.${prevIP[2]}.${prevIP[3]}`
            haulTrucksList.value.push({
                title   : finalIP,
                value   : finalIP,
            })
        })
    })
    .catch(function (error) {
        showConsoleError(error);
    });
    
    finalListTruck.value = haulTrucksList.value;
}



/**
 * Camión Seleccionado
 */
const haulTruckSelected = ref('');

/**
 * Obtiene las posiciones del camión seleccionado
 */

async function getHaulTruckPositions() {
    clearLayerSource('LayerRSRP','SourceRSRP');
    clearLayerSource('LayerRSRQ','SourceRSRQ');
    clearLayerSource('LayerRSSI','SourceRSSI');
    clearLayerSource('LayerSNR','SourceSNR');
    clearLayerSource('LayerLATENCIA','SourceLATENCIA');
    selectedRSRP.value = true;
    selectedRSRQ.value = false;
    selectedRSSI.value = false;
    selectedSNR.value = false;
    selectedLATENCIA.value = false;
    showError.value = false;
    showCheckBoxes.value = false;
    finalRSRPArray.value = [];
    // finalRSRPObject.value = {};  
    let params = { ip : haulTruckSelected.value }
    
    let api = CONSTAPIS.APIS.value.drive.getInfoDriveByIP;
    await axios.get(api,{params:params, timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}`}}).then(async(response)=>{

          /* eslint-disable */
        let finalItems:any = Papa.parse(response.data.body, {
            header: true, // Usa la primera fila como nombres de las claves en el JSON
            skipEmptyLines: true, // Ignorar líneas vacías
        });

        if(finalItems.data.length > 0) {
            let index = 0
            finalItems.data.forEach((item:DEFAULT_ITEMS) => {
                index = index + 1;
                
                let lat   = 30.972732;
                let lng   = -110.34928166;

                if(item.latitud && item.latitud !== '') { lat = parseFloat(item.latitud??'0'); }
                if(item.longitud && item.longitud !== '') { lng = parseFloat(item.longitud??'0'); }
                if(item.gpsLat && item.gpsLat !== '') { lat = parseFloat(item.gpsLat??'0'); }
                if(item.gpsLong && item.gpsLong !== '') { lng = parseFloat(item.gpsLong??'0'); }

                let rsrp = item.rsrp === '' ? 0 : parseFloat(item.rsrp);
                let latencia = item.latencia !== '' && item.latencia ? parseFloat(item.latencia)   : 0 ;
                let snr = item.snr === '' ? 0 : parseFloat(item.snr);
                let rssi = item.rssi === '' ? 0 : parseFloat(item.rssi);
                let rsrq = item.rsrq === '' ? 0 : parseFloat(item.rsrq);

                let colorrsrp = getColorByValue(rsrp, [-Infinity,-100,-90,-80],[COLORRED,COLORYELLOW, COLORGREEN, COLORBLUE]);
                let colorrsrq = getColorByValue(rsrq, [-Infinity,-20,-15,-10],[COLORRED,COLORYELLOW, COLORGREEN, COLORBLUE]);
                let colorrssi = getColorByValue(rssi, [-Infinity,-100,-85,-70],[COLORRED,COLORYELLOW, COLORGREEN, COLORBLUE]);
                let colorsnr  = getColorByValue(snr, [0,16,20],[COLORRED,COLORYELLOW, COLORGREEN]);
                let colorlate = getColorByValue(latencia, [0,100,200],[COLORGREEN,COLORYELLOW, COLORRED]);

                postPORTItems('rsrp',lat, lng, colorrsrp, rsrp !== 0 ? `RSRP: ${rsrp}dBm`: `Fuera de Linea`,index,item.fecha);
                postPORTItems('rsrq',lat, lng, colorrsrq, rsrq !== 0 ? `RSRQ: ${rsrq}dB` : `Fuera de Linea`,index,item.fecha);
                postPORTItems('rssi',lat, lng, colorrssi, rssi !== 0 ? `RSSI: ${rssi}dBm`: `Fuera de Linea`,index,item.fecha);
                postPORTItems('snr',lat, lng, colorsnr, `SNR: ${snr}dB`,index,item.fecha);
                postPORTItems('latencia',lat, lng, colorlate, `LATENCIA: ${latencia}ms`,index,item.fecha);
            })

            finalRSRPObject.value = { "features" : finalRSRPArray.value, type : "FeatureCollection" };
            await setSourceAndLayer('rsrp','SourceRSRP',finalRSRPObject.value,'LayerRSRP');

            finalRSRQObject.value = { "features" : finalRSRQArray.value, type : "FeatureCollection" };
            await setSourceAndLayer('rsrq','SourceRSRQ',finalRSRQObject.value,'LayerRSRQ');

            finalRSSIObject.value = { "features" : finalRSSIArray.value, type : "FeatureCollection" };
            await setSourceAndLayer('rssi','SourceRSSI',finalRSSIObject.value,'LayerRSSI');

            finalSNRObject.value = { "features" : finalSNRArray.value, type : "FeatureCollection" };
            await setSourceAndLayer('snr','SourceSNR',finalSNRObject.value,'LayerSNR');

            finalLATENCIAObject.value = { "features" : finalLATENCIAArray.value, type : "FeatureCollection" };
            await setSourceAndLayer('latencia','SourceLATENCIA',finalLATENCIAObject.value,'LayerLATENCIA');

            clearLayerSource('LayerRSRQ','SourceRSRQ');
            clearLayerSource('LayerRSSI','SourceRSSI');
            clearLayerSource('LayerSNR','SourceSNR');
            clearLayerSource('LayerLATENCIA','SourceLATENCIA');
            showCheckBoxes.value = true;
        }
        else {
            showError.value = true;
            showCheckBoxes.value = false;
        }
    })
    .catch(function (error) {
        showConsoleError(error);
    });
}

/**
 * Agrega los items al array correspondiente
 * @param tipo 
 * @param latitud 
 * @param longitud 
 * @param color 
 * @param valor 
 * @param index 
 * @param fecha 
 */
function postPORTItems(tipo:string, latitud:number, longitud:number, color:string, valor:string, index:number, fecha:string) {
    let finalITEM = {                        
            "type": "Feature",
            "properties": {
                "level": 0,
                "name": `AllGraph${tipo}`,
                "height": 40,
                "base_height": 0,
                "color": color,
                "center": [longitud,latitud],
                "valor": valor,
                "fecha" : fecha
            },
            "geometry": {
                "coordinates": [ getFinalPositions(latitud,longitud) ],
                "type": "Polygon"
            },
            'id': index 
    }
    if(tipo.toUpperCase() === 'RSRP')       { finalRSRPArray.value.push(finalITEM) }
    if(tipo.toUpperCase() === 'RSRQ')       { finalRSRQArray.value.push(finalITEM) }
    if(tipo.toUpperCase() === 'RSSI')       { finalRSSIArray.value.push(finalITEM) }
    if(tipo.toUpperCase() === 'SNR')        { finalSNRArray.value.push(finalITEM) }
    if(tipo.toUpperCase() === 'LATENCIA')   { finalLATENCIAArray.value.push(finalITEM) }
}

/**
 * Agrega el Layer y el Source al mapa
 * @param tipo 
 * @param source 
 * @param alldata 
 * @param layer 
 */
async function setSourceAndLayer(tipo:string, source:string, alldata:DRIVE_OBS, layer:string){
    const mySource = map.getSource(source);
    if(mySource === undefined){ 
        map.addSource(source, { 'type': 'geojson', 'data': alldata});        
        map.addLayer({
            'id': layer,
            'type': 'fill-extrusion',
            'source': source,
            'paint': {
                'fill-extrusion-color': ['get', 'color'],
                'fill-extrusion-height': ['get', 'height'],
                'fill-extrusion-base': ['get', 'base_height'],
                'fill-extrusion-opacity':1,
            }
        });
        
        const popup = new maplibregl.Popup({
            closeButton: false,
            closeOnClick: false
        });

        map.on('mouseenter', layer, (e:any) => {
            map.getCanvas().style.cursor = 'pointer';
            
            const coordinates:any = [e.lngLat.lng, e.lngLat.lat];
            const valor = e.features[0].properties.valor ;
            let mensaje = `${valor}` 

            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }

            popup.setLngLat(coordinates).setHTML(mensaje).addTo(map);
        });

        map.on('mouseleave', layer, () => {
            map.getCanvas().style.cursor = '';
            popup.remove();
        });
    }
    else{
        mySource.setData(alldata)
    }
}


/**
 * Limpia el layer y el source del mapa
 * @param layer 
 * @param source 
 */
function clearLayerSource(layer:string, source:string) {
    if(map.getLayer(layer)) { map.removeLayer(layer); }
    if(map.getSource(source)) { map.removeSource(source); }
}

/**
 * Observa los checkbox para agregar o quitar layers del mapa
 * @param selectedVar 
 * @param type 
 * @param source 
 * @param finalObject 
 * @param layer 
 */
function watchLayer(selectedVar: Ref<boolean>, type: string, source: string, finalObject: Ref<DRIVE_OBS>, layer: string) {
    watch(selectedVar, (state) => {
        if (state) {
            setSourceAndLayer(type, source, finalObject.value, layer);
        } else {
            clearLayerSource(layer, source);
        }
    });
}; 

watchLayer(selectedRSRP, 'rsrp', 'SourceRSRP', finalRSRPObject, 'LayerRSRP');
watchLayer(selectedRSRQ, 'rsrq', 'SourceRSRQ', finalRSRQObject, 'LayerRSRQ');
watchLayer(selectedRSSI, 'rssi', 'SourceRSSI', finalRSSIObject, 'LayerRSSI');
watchLayer(selectedSNR, 'snr', 'SourceSNR', finalSNRObject, 'LayerSNR');
watchLayer(selectedLATENCIA, 'latencia', 'SourceLATENCIA', finalLATENCIAObject, 'LayerLATENCIA');

/**
 * colores para el KMZ
 */
const color:STRINGS = {
    '#E04637' : '#lineStyleRed',
    '#F9DC4B' : '#lineStyleYellow',
    '#427739' : '#lineStyleGreen',
    '#CAC8C8' : '#lineStyleGrey',
    '#00A5E8' : '#lineStyleBlue',
}

/**
 * genera todas las coordenadas del KMZ
 * @param finalObject 
 */
function getAllCoordinates(finalObject: Ref<DRIVE_OBS>){
    let prevCoordinates = '';
    finalObject.value.features.forEach((element:DRIVE_PROPS) => {
        const finalCoord1 = (element.geometry.coordinates[0][0]);
        const finalCoord2 = (element.geometry.coordinates[0][1]);
        const finalCoord3 = (element.geometry.coordinates[0][2]);
        const finalCoord4 = (element.geometry.coordinates[0][3]);
        const finalCoord5 = (element.geometry.coordinates[0][4]);
        let someCoordinates = `
            <Placemark>
                <name>${element.id}</name>
                <description> 
                    <b>Detalles: </b> <br/>
                    Posicion: ${element.properties.center}<br/>
                    Valor:${element.properties.valor}.<br/>
                    Fecha:${element.properties.fecha}.
                </description>
                <styleUrl>${color[element.properties.color??'#CAC8C8']}</styleUrl>
                <MultiGeometry>
                    <Polygon>
                        <extrude>1</extrude>
                        <altitudeMode>relativeToGround</altitudeMode>
                        <outerBoundaryIs>
                            <LinearRing>
                            <coordinates>
                                ${finalCoord1[0]},${finalCoord1[1]},0
                                ${finalCoord2[0]},${finalCoord2[1]},0
                                ${finalCoord3[0]},${finalCoord3[1]},0
                                ${finalCoord4[0]},${finalCoord4[1]},0
                                ${finalCoord5[0]},${finalCoord5[1]},0
                            </coordinates>
                            </LinearRing>
                        </outerBoundaryIs>
                    </Polygon>
                    <Polygon>
                        <extrude>1</extrude>
                        <altitudeMode>relativeToGround</altitudeMode>
                        <outerBoundaryIs>
                            <LinearRing>
                            <coordinates>
                                ${finalCoord1[0]},${finalCoord1[1]},20
                                ${finalCoord2[0]},${finalCoord2[1]},20
                                ${finalCoord3[0]},${finalCoord3[1]},20
                                ${finalCoord4[0]},${finalCoord4[1]},20
                                ${finalCoord5[0]},${finalCoord5[1]},20
                            </coordinates>
                            </LinearRing>
                        </outerBoundaryIs>
                    </Polygon>
                </MultiGeometry>
            </Placemark>
        `
        prevCoordinates = prevCoordinates + someCoordinates
    })

    return prevCoordinates
}

/**
 * Genera los folders del KMZ
 * @param title 
 * @param finalCoords 
 */
function getFolderItems(title:string,finalCoords:string) {
    let folder =  `
        <Folder> 
            <name> ${title} </name>
            ${finalCoords}
        </Folder>
    `
    return folder
}

/**
 * Genera el archivo KMZ
 */
async function getKMZ () {

    const iconUrl = window.location.origin + miIconoPersonalizado;

 // Contenido del archivo KML
 let kmlContent = `<?xml version="1.0" encoding="UTF-8"?>
  <kml xmlns="http://www.opengis.net/kml/2.2">
    <Document>
      <name>EQUIPO : ${haulTruckSelected.value}</name>

    <Style id="lineStyleRed">
      <LineStyle>
        <color>ff00ffff</color>
        <width>1</width>
      </LineStyle>
      <PolyStyle>
        <color>ff00ffff</color> 
        <fill>1</fill>
      </PolyStyle>
    </Style>

    <Style id="lineStyleYellow">
      <LineStyle>
        <color>ff00ffff</color>
        <width>1</width>
      </LineStyle>
      <PolyStyle>
        <color>ff00ffff</color> 
        <fill>1</fill>
      </PolyStyle>
    </Style>

    <Style id="lineStyleGreen">
      <LineStyle>
        <color>ff00ff00</color>
        <width>1</width>
      </LineStyle>
      <PolyStyle>
        <color>ff00ff00</color> 
        <fill>1</fill>
      </PolyStyle>
    </Style>

    <Style id="lineStyleGrey">
      <LineStyle>
        <color>ff808080</color>
        <width>1</width>
      </LineStyle>
      <PolyStyle>
        <color>ff808080</color> 
        <fill>1</fill>
      </PolyStyle>
    </Style>

    <Style id="lineStyleBlue">
      <LineStyle>
        <color>ffff0000</color>
        <width>1</width>
      </LineStyle>
      <PolyStyle>
        <color>ffff0000</color> 
        <fill>1</fill>
      </PolyStyle>
    </Style>
    <Style id="customMarkerStyle">
        <IconStyle>
            <scale>1.2</scale>
            <Icon>
                <href>${iconUrl}</href> 
            </Icon>
        </IconStyle>
    </Style>
    `
    const finalRSRPCoords       = getAllCoordinates(finalRSRPObject)
    const finalRSRQCoords       = getAllCoordinates(finalRSRQObject)
    const finalRSSICoords       = getAllCoordinates(finalRSSIObject)
    const finalSNRCoords        = getAllCoordinates(finalSNRObject)
    const finalLATENCIACoords   = getAllCoordinates(finalLATENCIAObject)

    let finalFolderRSRP         = getFolderItems('RSRP',finalRSRPCoords)
    let finalFolderRSRQ         = getFolderItems('RSRQ',finalRSRQCoords)
    let finalFolderRSSI         = getFolderItems('RSSI',finalRSSICoords)
    let finalFolderSNR          = getFolderItems('SNR',finalSNRCoords)
    let finalFolderLATENCIA     = getFolderItems('LATENCIA',finalLATENCIACoords)

     
    let markersFolder = ` <Folder> <name> Equipos Ap Fijo y Ap Movil </name> `
    allMarkerData.value.forEach((marker:any) => {
        if(marker.tipo.toLowerCase() === 'ap fijo' || marker.tipo.toLowerCase() === 'ap movil') {   
            const coords = JSON.parse(marker.gps);
            const lng = coords[1];
            const lat = coords[0];
            let markerItem = `
                <Placemark>
                    <name>${marker.name}</name>
                    <description>Tipo: ${marker.tipo} <br/> IP: ${marker.ip} </description>
                    <styleUrl>#customMarkerStyle</styleUrl>
                    <Point>
                        <coordinates>${lng},${lat},0</coordinates>
                    </Point>
                </Placemark>
            `
            markersFolder = markersFolder + markerItem
        }
    })
    markersFolder = markersFolder + `</Folder>`
      
  let finalKmlConent = `
   </Document>
  </kml>
  `

  kmlContent = kmlContent + markersFolder  + finalFolderRSRP + finalFolderRSRQ + finalFolderRSSI + finalFolderSNR + finalFolderLATENCIA + finalKmlConent;

  // Crear un Blob con el contenido del KML
  const blob = new Blob([kmlContent], { type: "application/vnd.google-earth.kml+xml" });
  const url = URL.createObjectURL(blob);

  // Crear un enlace y simular el clic para descargar
  const link = document.createElement("a");
  link.href = url;
  link.download = `KML-EQUIPO: ${haulTruckSelected.value}.kml`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}



const allMarkerData = ref<any>([]);

async function getAllRajantPositions() {
    const allData = await getRajantLastGPS()

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        allMarkerData.value = allData.data;
        agregarMarcadores(map, allData.data);
    }
}



// 1. Variables reactivas
const mostrarEquipos = ref(true); // Estado del checkbox (empieza marcado)
const marcadoresActivos = shallowRef([]); // Aquí guardaremos los pines para poder modificarlos

// 2. Observador (Watch): Reacciona cuando haces clic en el checkbox
watch(mostrarEquipos, (estaVisible) => {
  // Recorremos todos los marcadores guardados y cambiamos su estilo CSS
  marcadoresActivos.value.forEach((marker:any) => {
    const elementoHtml = marker.getElement();
    // Si estaVisible es true, lo mostramos (block). Si es false, lo ocultamos (none)
    elementoHtml.style.display = estaVisible ? 'block' : 'none';
  });
});

// 3. Tu función actualizada
const agregarMarcadores = (mapaInstancia:any, datosEquipos:any) => {
  if (!mapaInstancia) return;

  // Limpiamos los marcadores anteriores si la API se llama múltiples veces
  marcadoresActivos.value.forEach((m:any) => m.remove());
  const nuevosMarcadores:any = []; // Arreglo temporal

  datosEquipos.forEach((equipo:any) => {
    if(equipo.tipo.toLowerCase() === 'ap fijo' || equipo.tipo.toLowerCase() === 'ap movil') {
        const coords = JSON.parse(equipo.gps);
        const lng = coords[1];
        const lat = coords[0];

        // Contenedor principal del marcador
        const el = document.createElement('div');
        el.style.backgroundImage = `url(${miIconoPersonalizado})`;
        el.style.width = '32px';  
        el.style.height = '32px'; 
        el.style.backgroundSize = 'cover';
        el.style.backgroundPosition = 'center';
        el.style.cursor = 'pointer';

        // Etiqueta del nombre
        const nameLabel = document.createElement('div');
        nameLabel.textContent = equipo.name; 
        nameLabel.style.color = '#ffffff';
        nameLabel.style.backgroundColor = 'rgba(0, 0, 0, 0.75)'; 
        nameLabel.style.fontSize = '11px';
        nameLabel.style.fontWeight = 'bold';
        nameLabel.style.padding = '2px 6px';
        nameLabel.style.borderRadius = '4px';
        nameLabel.style.position = 'absolute';
        nameLabel.style.top = '100%'; 
        nameLabel.style.left = '50%';
        nameLabel.style.transform = 'translate(-50%, 2px)'; 
        nameLabel.style.whiteSpace = 'nowrap'; 
        
        el.appendChild(nameLabel);

        // Respetar el estado actual del checkbox antes de agregar al mapa
        if (!mostrarEquipos.value) {
        el.style.display = 'none';
        }

        // Crear el marcador
        const marker = new maplibregl.Marker({
        element: el,
        anchor: 'bottom'
        })
        .setLngLat([lng, lat])
        .addTo(mapaInstancia);

        // Guardar en el arreglo temporal
        nuevosMarcadores.push(marker);
    }
  });

  // Guardamos todos los marcadores nuevos en la variable reactiva
  marcadoresActivos.value = nuevosMarcadores;
};


let map:any = '' ;
const centerMap = ref<LngLatLike>([CONSTMAPS.longitud.value,CONSTMAPS.latitud.value])

onMounted(async() => {    
    
    map  = new maplibregl.Map({
        container: 'map',
        center: centerMap.value,
        zoom: 14,
        pitch: 40,
        bearing: 30,
        antialias: true,
        style: 'https://api.maptiler.com/maps/satellite/style.json?key=6JWVt6LFaY22nquimZpF',
    });
    
    map.addControl(new maplibregl.NavigationControl());

    getAllHaulTrucks();

    getAllRajantPositions();
})


return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!

  return (_openBlock(), _createBlock(_component_v_sheet, {
    class: "defaultCard",
    color: "bgtopology"
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(title.value), 1),
      _createVNode(_component_v_row, { class: "ma-0 mt-8" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_sheet, {
            color: "transparent",
            style: _normalizeStyle(_unref(mdAndDown) ?'width: 100%' :`width: calc(100% - ${width.value}px)`)
          }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
              _createElementVNode("div", { id: "map" }, null, -1)
            ]))]),
            _: 1
          }, 8, ["style"]),
          _createVNode(_component_v_col, {
            class: "pa-0",
            cols: "12",
            sm: "12",
            md: "12",
            lg: "2",
            xl: "2",
            xxl: "2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_sheet, {
                color: "transparent",
                class: "pa-4 pr-0",
                width: width.value
              }, {
                default: _withCtx(() => [
                  _cache[16] || (_cache[16] = _createElementVNode("h3", { class: "subtitlePages" }, "Heatmap", -1)),
                  _createVNode(_component_v_row, { class: "ma-0 mt-3 mb-3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "6",
                        class: "pa-0 pr-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            variant: "outlined",
                            density: "compact",
                            label: "Duración (min.)",
                            type: "number",
                            "hide-spin-buttons": "",
                            modelValue: minutes.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((minutes).value = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "6",
                        class: "pa-0 pl-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            variant: "outlined",
                            density: "compact",
                            label: "Intervalo (seg.)",
                            type: "number",
                            "hide-spin-buttons": "",
                            modelValue: interval.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((interval).value = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_btn, {
                        onClick: startHeatMap,
                        block: "",
                        color: "success",
                        disabled: disabledAXIOS.value
                      }, {
                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                          _createTextVNode(" Iniciar ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  }),
                  (disabledAXIOS.value)
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 0,
                        class: "ma-0 mt-2 mb-4",
                        justify: "center"
                      }, {
                        default: _withCtx(() => [
                          _cache[12] || (_cache[12] = _createTextVNode(" Cargando Información ", -1)),
                          _createVNode(_component_v_progress_linear, {
                            "model-value": progress.value,
                            height: "20",
                            color: "green",
                            striped: "",
                            active: isRunning.value,
                            class: "mt-4"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(Math.floor(progress.value)) + "% ", 1)
                            ]),
                            _: 1
                          }, 8, ["model-value", "active"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_row, { class: "ma-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        class: "pa-0"
                      }, {
                        default: _withCtx(() => [
                          _cache[13] || (_cache[13] = _createElementVNode("h3", null, " Búsqueda ", -1)),
                          _createVNode(_component_v_select, {
                            modelValue: haulTruckSelected.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((haulTruckSelected).value = $event)),
                            items: computedListTruck.value,
                            disabled: computedListTruck.value.length == 0,
                            "item-title": "title",
                            "item-value": "value",
                            density: "compact",
                            variant: "outlined",
                            "hide-details": ""
                          }, null, 8, ["modelValue", "items", "disabled"]),
                          _createVNode(_component_v_btn, {
                            class: "mt-4",
                            color: "success",
                            disabled: haulTruckSelected.value==='',
                            block: "",
                            onClick: getHaulTruckPositions
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('buttons.searchTruck')), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (showError.value)
                    ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, null, {
                            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                              _createTextVNode("No hay informacion", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_checkbox, {
                    modelValue: mostrarEquipos.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((mostrarEquipos).value = $event)),
                    color: "green",
                    label: "Mostrar Equipos",
                    "hide-details": ""
                  }, null, 8, ["modelValue"]),
                  (showCheckBoxes.value)
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 2,
                        class: "ma-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            class: "pa-0",
                            cols: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_checkbox, {
                                modelValue: selectedRSRP.value,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedRSRP).value = $event)),
                                color: "green",
                                label: "RSRP",
                                "hide-details": ""
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_v_checkbox, {
                                modelValue: selectedRSRQ.value,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedRSRQ).value = $event)),
                                color: "green",
                                label: "RSRQ",
                                "hide-details": ""
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_v_checkbox, {
                                modelValue: selectedRSSI.value,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedRSSI).value = $event)),
                                color: "green",
                                label: "RSSI",
                                "hide-details": ""
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_v_checkbox, {
                                modelValue: selectedSNR.value,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedSNR).value = $event)),
                                color: "green",
                                label: "SNR",
                                "hide-details": ""
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_v_checkbox, {
                                modelValue: selectedLATENCIA.value,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((selectedLATENCIA).value = $event)),
                                color: "green",
                                label: "Latencia",
                                "hide-details": ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                color: "red",
                                block: "",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (getKMZ()))
                              }, {
                                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                  _createTextVNode(" Generar KMZ ", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["width"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})